import React from "react";
import reload from "../../image/reload.png";
import "../../style/common/reload.scss";

const Reload = (props) => {
  return (
    <div className={`reload-mask ${props.reloadingShow ? "show" : ""}`}>
      <div className="reload">
        <div className="box">
          <img src={reload} alt="" className="reload-img" />
          <p>Linking payment gateway partners...</p>
        </div>
      </div>
    </div>
  );
};

export default Reload;
